<template>
	<el-dialog top="30vh" class="ranking-dialog" :visible="visible" @close="close" width="30%" show-close>
	  
		<span slot="title">
			达人榜规则
		</span>
		<div class="ranking-dialog-content" v-if="type==1">
			<div class="content-title">主播达人榜规则：</div>
			<p>
				1.日榜：统计每日00:00:00至每日23:59:59时间段内粉丝新增数量,最高到最低进行排序；
			</p>
			<p>
				2.周榜：统计每周一00:00:00至周日23:59:59时间段内粉丝新增数量,最高到最低进行排序；
			</p>
			<p>
				3.月榜：统计每月1日00:00:00至月末最后一天23:59:59时间段内粉丝新增数量,最高到最低进行排；
			</p>
		</div>
		
		<div class="ranking-dialog-content" v-else>
			<div class="content-title">富豪达人榜规则：</div>
			<!--
			<p>
			(贡献值计算方式:1克拉=10贡献值)
			</p>
			-->
			<p>
				1.日榜：统计每日00:00:00至每日23:59:59时间段内贡献值,最高到最低进行排序；
			</p>
			<p>
				2.周榜：统计每周一00:00:00至周日23:59:59时间段内贡献值,最高到最低进行排序；
			</p>
			<p>
				3.月榜：统计每月1日00:00:00至月末最后一天23:59:59时间段内贡献值,最高到最低进行排序；
			</p>
		</div>
		
	</el-dialog>
</template>

<script>
	import { post } from "@/util/http";
	export default {
		props:{
			title:{
				type: String,
				default: ""
			}
		},
		data(){
			return {
				visible : false,
				detail: {
					title: "",
					content: ""
				},
				type: 1,
				loading : false
			}
		},
		methods:{
			open(type=1){
				this.loading = true;
				this.visible = true;
				this.type = type;
			},
			close(){
				this.visible = false;
			},
			cancel(){
				this.$emit("cancel");
				this.close();
			},
			
			// 作废
			getData(){
				let data = {
					id: this.type
				}
				post({
					url: "/api/live/top_user_desc",
					data: data
				}).then(({ data: { data } })=>{
					// console.log("data: ",data);
					this.loading = false;
					this.detail = data;
				})
				.catch(err=>{
					this.loading = false;
				})
			}
		}
	}
</script>

<style  scoped lang="stylus">
	
	.ranking-dialog {
		/deep/{
			.el-dialog{
				border-radius : .2rem;
			}
			.el-dialog__header{
				font-size : .18rem;
				color : #333333;
				border-bottom : .01rem solid #f3f3f3;
			}
			.el-dialog__headerbtn{
				bottom: -0.4rem;
				top: auto;
				left: 50%;
				right: auto;
				transform: translateX(-50%);
			}
			.el-icon-close {
				color : #ffffff;
				background: rgba(51, 51, 51, 0.5);
				border-radius: 50%;
				padding : .05rem;
			}
			.el-dialog__body{
				padding-top : .1rem;
			}
		}
		.content-title{
			font-size : .17rem;
			padding-bottom : .1rem;
			color : #333333;
		}
	  .ranking-dialog-content{
			font-size : .15rem;
			line-height: .24rem;
		}
	}
</style>